export default "__VITE_PUBLIC_ASSET__1a637e7d__"